const { __ } = wp.i18n;

export function Comparison_Tables_toRGBA( c ) {
    var can  = document.createElement( 'canvas' ),
        ctx  = can.getContext( '2d' );
    can.width = can.height = 1;
    ctx.fillStyle = c;
    ctx.fillRect( 0, 0, 1, 1 ); //paint the canvas
    var
        img  = ctx.getImageData( 0, 0, 1, 1 ),
        data = img.data,
        rgba = {
            r: data[ 0 ], //0-255 red
            g: data[ 1 ], //0-255 green
            b: data[ 2 ], //0-255 blue
            a: data[ 3 ]  //0-255 opacity (0 being transparent, 255 being opaque)
        };
    return rgba;
}

export function AZON_Country_List( alias='all' ){
  const list = [ 
    { 
      'alias': 'com',
      'label': 'United States',
      'flag': '/flags/US.gif',
      'api_url': 'https://ws-na.amazon-adsystem.com/widgets/q?TemplateId=PubStudio&ServiceVersion=20070822&MarketPlace=US&Operation=ItemSearch&InstanceId={InstanceId}&dataType=jsonp&Keywords={Keywords}&SearchIndex={SearchIndex}&multipageStart={paged}&multipageCount={items_per_page}'
    },
    { 
      'alias': 'co.uk',
      'label': 'United Kingdom',
      'flag': '/flags/UK.gif',
      'api_url': 'https://ws-eu.amazon-adsystem.com/widgets/q?Operation=GetResults&MarketPlace=GB&Keywords={Keywords}&SearchIndex={SearchIndex}&multipageStart={paged}&InstanceId={InstanceId}&multipageCount={items_per_page}&TemplateId=MobileSearchResults&ServiceVersion=20070822'
    },
    { 
      'alias': 'de',
      'label': 'Deutschland',
      'flag': '/flags/DE.gif',
      'api_url': 'https://ws-eu.amazon-adsystem.com/widgets/q?Operation=GetResults&MarketPlace=DE&Keywords={Keywords}&SearchIndex={SearchIndex}&multipageStart={paged}&InstanceId={InstanceId}&multipageCount={items_per_page}&TemplateId=MobileSearchResults&ServiceVersion=20070822'
    },
    { 
      'alias': 'fr',
      'label': 'France',
      'flag': '/flags/FR.gif',
      'api_url': 'https://ws-eu.amazon-adsystem.com/widgets/q?Operation=GetResults&MarketPlace=FR&Keywords={Keywords}&SearchIndex={SearchIndex}&multipageStart={paged}&InstanceId={InstanceId}&multipageCount={items_per_page}&TemplateId=MobileSearchResults&ServiceVersion=20070822'
    },
    { 
      'alias': 'jp',
      'label': 'Japan',
      'flag': '/flags/JP.gif',
      'api_url': 'https://ws-fe.amazon-adsystem.com/widgets/q?Operation=GetResults&Keywords={Keywords}&SearchIndex={SearchIndex}&multipageStart={paged}&InstanceId={InstanceId}&multipageCount={items_per_page}&TemplateId=MobileSearchResults&ServiceVersion=20070822&MarketPlace=JP'
    },
    { 
      'alias': 'ca',
      'label': 'Canada',
      'flag': '/flags/CA.gif',
      'api_url': 'https://ws-na.amazon-adsystem.com/widgets/q?TemplateId=PubStudio&ServiceVersion=20070822&MarketPlace=CA&Operation=ItemSearch&InstanceId={InstanceId}&dataType=jsonp&Keywords={Keywords}&SearchIndex={SearchIndex}&multipageStart={paged}&multipageCount={items_per_page}'
    },
    { 
      'alias': 'it',
      'label': 'Italia',
      'flag': '/flags/IT.gif',
      'api_url': 'https://ws-eu.amazon-adsystem.com/widgets/q?Operation=GetResults&MarketPlace=IT&Keywords={Keywords}&SearchIndex={SearchIndex}&multipageStart={paged}&InstanceId={InstanceId}&multipageCount={items_per_page}&TemplateId=MobileSearchResults&ServiceVersion=20070822'
    },
    { 
      'alias': 'es',
      'label': 'España',
      'flag': '/flags/ES.gif',
      'api_url': 'https://ws-eu.amazon-adsystem.com/widgets/q?Operation=GetResults&MarketPlace=ES&Keywords={Keywords}&SearchIndex={SearchIndex}&multipageStart={paged}&InstanceId={InstanceId}&multipageCount={items_per_page}&TemplateId=MobileSearchResults&ServiceVersion=20070822'
    },
    { 
      'alias': 'in',
      'label': 'India',
      'flag': '/flags/IN.gif',
      'api_url': 'https://ws-eu.amazon-adsystem.com/widgets/q?Operation=GetResults&MarketPlace=IN&Keywords={Keywords}&SearchIndex={SearchIndex}&multipageStart={paged}&InstanceId={InstanceId}&multipageCount={items_per_page}&TemplateId=MobileSearchResults&ServiceVersion=20070822'
    }
  ]

  if( alias == 'all' ) return list;

  let country = '';
  list.forEach( row => {
    if( alias == row.alias ){
      country = row;
    }
  });

  return country;
}

export function Comparison_Tables_Items_Types( give_item='all' ) {
  const items = {
    'info': {
      'name': __('Informational Box', 'aat-apct'),
      'icon': `${Pro_Notify.assets_url}/icons/info/icon.png`,
      'preview': `${Pro_Notify.assets_url}/icons/info/preview.png`
    }
  }

  return items;
}

export function Comparison_Tables_objectMove( items, oldIndex, newIndex ) {
  console.log( items, oldIndex, newIndex );
}


export function Comparison_Tables_domain_from_url(url) {
    var result
    var match
    if (match = url.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n\?\=]+)/im)) {
        result = match[1]
        if (match = result.match(/^[^\.]+\.(.+\..+)$/)) {
            result = match[1]
        }
    }
    return result.split(".")[1]
}

export function Comparison_Tables_Product_Url( ASIN, country='com', type='detail' ) {

  const country_obj = AZON_Country_List( country );

  let aff_id = Comparison_Tables_isset( Comparison_Tables, 'affIDs', country ) ? Comparison_Tables.affIDs[country] : 'InvalidTAG';
  if( type == 'cart' ){
    return `https://www.amazon.${country_obj.alias}/gp/aws/cart/add.html?AssociateTag=${aff_id}&ASIN.1=${ASIN}&Quantity.1=1`;
  }
  
  return `https://amazon.${country_obj.alias}/dp/${ASIN}?tag=${aff_id}`;
}

export function Comparison_Tables_isset( arr, var_args ) {
  for (var i=1, k=arguments.length; i<k; ++i) {
    if (!arr || !arr.hasOwnProperty(arguments[i]) )
      return false
    arr = arr[arguments[i]];
  }
  return true
}

export function Comparison_Tables_Parse_Product_Data( page, exclude_elements )
{
  const $ = jQuery;
  var exclude_elements = exclude_elements || [],
    product = {};

  // title
  if( $.inArray( 'title', exclude_elements ) === -1 ) {
    product.title = jQuery.trim( page.find('#productTitle, #ebooksProductTitle, #mas-title').eq(0).text() );
  }

  // description
  if( $.inArray( 'description', exclude_elements ) === -1 ) {
    var _description = page.find('#productDescription, #mas-product-description > div').eq(0).html();
    _description = jQuery.trim( _description ).replace(/\t/g, "").replace(/\n/g, "")
    product.description = _description;
  }

  // brand
  if( $.inArray( 'brand', exclude_elements ) === -1 ) {
    product.brand = jQuery.trim( page.find('#bylineInfo').eq(0).text() );
  }

  // price
  if( $.inArray( 'amazon_price', exclude_elements ) === -1 ){
    product.amazon_price = jQuery.trim( page.find('#priceblock_ourprice, #priceblock_dealprice, #priceblock_saleprice').eq(0).text() );
  }
  if( $.inArray( 'list_price', exclude_elements ) === -1 ) {
    product.list_price = jQuery.trim( page.find('#price .a-text-strike').eq(0).text() );
  }

  // short description
  if( $.inArray( 'short_description', exclude_elements ) === -1 ) {
    var _shortdesc_ = page.find('#featurebullets_feature_div ul li, #mas-product-feature ul li'),
      _shortdesc_2 = [];

    $.each( _shortdesc_, function(idx) {
      var _that = $(this),
        _text = _that.text();

      _text = $.trim( _text ).replace(/\t/g, "").replace(/\n/g, "");
      _shortdesc_2.push( _text );
    });
    product.short_description = _shortdesc_2.join("\n");
  }

  // images
  if( $.inArray( 'images', exclude_elements ) === -1 ) {
    product.images = [];

    var _images = page.find("#imageBlock #altImages ul li:not(.360IngressTemplate,.videoCountTemplate,.videoThumbnail) .a-button-thumbnail img");

    // ebooks cases
    if ( ! _images.length ) {
      _images = page.find("#booksImageBlock_feature_div #imageBlockThumbs .imageThumb.thumb img");
    }
    if ( ! _images.length ) {
      _images = page.find("#booksImageBlock_feature_div #minimalImageBlock #mainImageContainer img");
    }
    if ( ! _images.length ) {
      _images = page.find("#imageBlockNew_feature_div #ebooksImageBlock #ebooks-img-canvas img");
    }
    if ( ! _images.length ) {
      _images = page.find("#imageBlock_feature_div .image-wrapper img");
    }

    _images.each( function( element ) {
      product.images.push({
        'url': $(this).attr('src').replace(/._(.*)_/i, ''),
        'large': []
      });
    });
  }

  // flags
  if( $.inArray( 'amazonprime', exclude_elements ) === -1 ){
    product.amazonprime = page.find('#price .a-icon.a-icon-prime').length ? 1 : 0;
  }
  if( $.inArray( 'freeshipping', exclude_elements ) === -1 ){
    product.freeshipping = page.find('#price #ourprice_shippingmessage #price-shipping-message').length ? 1 : 0;
  }


  //=====================================================
  //:: EBOOKS

  //:: price
  //https://www.amazon.com/gp/product/1680229001/
  if ( '' == product.amazon_price ) {
    //.offer-price.a-color-price
    product.amazon_price = jQuery.trim( page.find('#buybox #buyNewSection .a-color-price').eq(0).text() );
  }

  //https://www.amazon.com/gp/product/B07GC1FC9Z/
  if ( '' == product.amazon_price ) {
    product.amazon_price = jQuery.trim( page.find('#buybox .kindle-price .a-color-price').eq(0).text() );
  }

  //https://www.amazon.co.uk/dp/B01CJBBXOE/
  if ( '' == product.amazon_price ) {
    product.amazon_price = jQuery.trim( page.find('#buybox #unqualifiedBuyBox .a-color-price').eq(0).text() );
  }

  //https://www.amazon.com/Dr-Bernsteins-Diabetes-Solution-Achieving/dp/0316182699/ref=mt_hardcover?_encoding=UTF8&me=&qid=
  if ( '' == product.amazon_price ) {
    product.amazon_price = jQuery.trim( page.find('#newOfferAccordionRow .header-price').eq(0).text() );
  }
  
  //https://www.amazon.com/Dr-Bernsteins-Diabetes-Solution-Achieving/dp/1478969954/ref=mt_audiobook?_encoding=UTF8&me=&qid=
  if ( '' == product.amazon_price ) {
    product.amazon_price = jQuery.trim( page.find('#mediaNoAccordion .header-price').eq(0).text() );
  }

  //:: short description
  if( $.inArray( 'short_description', exclude_elements ) === -1 ) {
    
    if ( ! product.short_description.length ) {

      var _shortdesc_ = page.find('#bookDescription_feature_div #bookDesc_iframe_wrapper #bookDesc_iframe')
        .contents().find('#iframeContent');

      _shortdesc_ = _shortdesc_.text();
      product.short_description = [ _shortdesc_ ];
    }
  }

  function get_container_text( $wrapp ) {
    return $wrapp.contents().filter(function () {
          return this.nodeType === Node.TEXT_NODE;
    }).text();
  }

  //:: attributes
  if( $.inArray( 'item_attributes', exclude_elements ) === -1 ) {

    if ( $.isEmptyObject( product.item_attributes ) ) {

      var _item_attributes = page.find('#detail-bullets table .content ul').eq(0),
        _item_attributes2 = {};

      _item_attributes.find('> li').each(function(){
        var row = $(this),
          td1 = row.find("b:first, strong:first").eq(0).text(),
          td2 = null;

        td1 = td1.replace(':', '');
        td1 = $.trim( td1 );

        td2 = get_container_text( row );
        td2 = $.trim( td2 );
        if ( '' == td2 ) {
          td2 = row.find('a').text();
          td2 = $.trim( td2 );
        }

        if ( '' == td2 ) {
          return true;
        }

        var skip_elements = [
          'ASIN',
          'Amazon Best Sellers Rank',
          'Average Customer Review'
        ];
        if ( $.inArray( td1, skip_elements ) == -1 ) {
          _item_attributes2[td1] = td2;
        }
      });

      if ( ! $.isEmptyObject( _item_attributes2 ) ) {
        product.item_attributes = _item_attributes2;
      }
    }
  }

  //:: authors
  // authors block code must be bellow the attributes block code, so we can add authors to attributes list
  var is_ebook = false;

  function hasOwnProperty(obj, prop) {
    var proto = obj.__proto__ || obj.constructor.prototype;
    return (prop in obj) &&
    (!(prop in proto) || proto[prop] !== obj[prop]);
  }

  if( $.inArray( 'authors', exclude_elements ) === -1 ) {
    var _authors = page.find('#bylineInfo').eq(0),
      _authors2 = {};

    if ( _authors.length ) {
      _authors.find('> span.author').each( function(){
        var row = $(this),
          td1 = row.find("> span:first, > a:first").eq(0).text(),
          td2 = row.find("> span.contribution").eq(0).text();

        td1 = $.trim( td1 );

        td2 = td2.replace(',', '').replace('(', '').replace(')', '');
        td2 = $.trim( td2 );

        if ( ! hasOwnProperty( _authors2, td2 ) ) {
          _authors2[ td2 ] = [];
        }
        _authors2[ td2 ].push( td1 );
      });
    }

    if ( ! $.isEmptyObject( _authors2 ) ) {

      is_ebook = true;

      var _authors3 = {};
      for (var i1 in _authors2) {
        var _tmp = _authors2[ i1 ];

        for (var i2 in _tmp) {
          _authors3[ i1 + ( i2 > 0 ? ' ' + (+i2+1) : '' ) ] = _tmp[ i2 ];
        }
      }

      product.brand = '';
      product.authors = _authors3;

      if( $.inArray( 'item_attributes', exclude_elements ) === -1 ) {
        product.item_attributes = $.extend( false, product.item_attributes, product.authors );
      }
    }
  }

  // title
  if ( is_ebook ) {
    if( $.inArray( 'title', exclude_elements ) === -1 ) {
      var $title = page.find('#productTitle, #ebooksProductTitle, #mas-title').parents('#title').eq(0),
        _title = $title.text();

      _title = $.trim( _title ).replace(/\t/g, "").replace(/\n/g, "").replace(/ +/g, " ");
      _title = $.trim( _title );

      product.title = _title;
    }
  }

  const technical_details = page.find("#tech-specs-desktop");
  const tables = technical_details.find("table");
  product.technical_specification = {};

  // get from HLCXComparisonTable to other product, if exist
  const compare_hlcx_html = page.find("#HLCXComparisonTable");
  let compare_hlcx_arr = [];
  compare_hlcx_html.find("tr.comparison_other_attribute_row").each( function(ii){
    const that = $(this);
    product.technical_specification[$.trim(that.find("th.comparison_table_first_col").text())] = $.trim(that.find("td.comparison_baseitem_column").text());
  })


  page.find("#productDetails_techSpec_section_2 tr").each( function() {
    const that = $(this);
    product.technical_specification[$.trim(that.find("th").eq(0).text())] = $.trim(that.find("td").eq(0).text());
  })

  // get from compar to other product, if exist
  const compare_html = page.find("#compare table");
  let compare_arr = [];
  compare_html.find("tr").each( function(ii){
    if( ii > 2 ){
      const that = $(this);

     that.find("td").each( function(cc) {
      if( cc < 2 ){
        const that2 = $(this);
        compare_arr.push( $.trim(that2.text()) )
      }
     })
    }
  })

  if( compare_arr.length ){
    for (let i = 0; i <= compare_arr.length - 1; i++) {
      product.technical_specification[compare_arr[i]] = compare_arr[++i];
    }
  }

  // get from tech specification, if exist
  tables.each( function(){
    $(this).find("tr").each(function(){
      const tr = $(this);
      product.technical_specification[$.trim(tr.find('td').eq(0).text())] = $.trim(tr.find('td').eq(1).text());
    })
  })

  const rating_html = page.find("#averageCustomerReviews");
  let rating_value = parseFloat( rating_html.find(".a-icon.a-icon-star").text().split(" ")[0] );
  let rating_vote_count = parseFloat( rating_html.find("#acrCustomerReviewText").text() );

  product.ratings = {
    'value': rating_value,
    'count': rating_vote_count,
  }

  return product;
}

export function Comparison_Tables_Color_MakeID(length=10) {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < length; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
}

export function Comparison_Tables_Color( number_of_color=999 )
{
  let original_colors = [
    {name:"WHITE", hex:"#ffffff"},
    {name:"BLACK", hex:"#000"},
    {name:"ORANGE", hex:"#f39c12"},
    {name:"PUMPKIN", hex:"#d35400"},
    {name:"POMEGRANATE", hex:"#c0392b"},
    {name:"SILVER", hex:"#bdc3c7"},
    {name:"ASBESTOS", hex:"#7f8c8d"},
    {name:"TURQUOISE", hex:"#1abc9c"},
    {name:"EMERALD",hex:"#2ecc71"},
    {name:"PETER RIVER", hex:"#3498db"},
    {name:"AMETHYST", hex:"#9b59b6"},
    {name:"WET ASPHALT", hex:"#34495e"},
    {name:"GREEN SEA", hex:"#16a085"},   
    {name:"BELIZE HOLE", hex:"#2980b9"},
    {name:"MIDNIGHT BLUE", hex:"#2c3e50"}
  ];

  let return_colors = [];
  original_colors.forEach( (color) => {
    return_colors.push({
      'name': color.name,
      'color': color.hex,
      'slug': color.name.toLowerCase()
    })
  })

  if( number_of_color < 999 ){
    return return_colors.slice( 0, number_of_color )
  }

  return return_colors;
}

export function Comparison_Tables_GoogleFontLoader( font ){

  let fetchStyle = function(url) {
    return new Promise((resolve, reject) => {
      let link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.onload = function() { resolve() };
      link.href = url;

      let headScript = document.querySelector('script');
      headScript.parentNode.insertBefore(link, headScript);
    });
  };

  if( font == "Theme Default" ) return false;
  if( font == "Arial" ) return false;
  
  if( !Pro_Notify.google_fonts.includes(font) ){
    fetchStyle( `https://fonts.googleapis.com/css?family=` + font.replace(" ", "+") );
    Pro_Notify.google_fonts.push( font );
  }
}


// WEBPACK FOOTER //
// ./src/utils.js